/**
 * Stichpunkte auf der Produktseite: Ab dem fuenften Punkt eingeklappt, damit
 * Variante und Warenkorb-Button nicht nach unten rutschen; der Link nennt die
 * Zahl der weiteren Punkte ("Mehr anzeigen (3)", wie bei Shop4Tesla). Vorher
 * ab dem vierten - dort steht oft der Lieferumfang. Ohne JavaScript bleiben
 * alle Punkte sichtbar.
 */
(function () {
  const LIMIT = 4;
  const setup = (root) => {
    if (root.dataset.highlightsReady) {
      return;
    }
    root.dataset.highlightsReady = 'true';
    root.querySelectorAll('ul').forEach((list, index) => {
      const items = list.querySelectorAll(':scope > li');
      if (items.length <= LIMIT + 1) {
        return;
      }
      if (!list.id) {
        list.id = 'product-highlights-' + index;
      }
      list.classList.add('product-highlights__list--collapsed');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'product-highlights__toggle';
      button.setAttribute('aria-controls', list.id);
      button.setAttribute('aria-expanded', 'false');
      const moreLabel = (root.dataset.more || '+') + ' (' + (items.length - LIMIT) + ')';
      button.textContent = moreLabel;
      button.addEventListener('click', () => {
        const collapsed = list.classList.toggle('product-highlights__list--collapsed');
        button.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        button.textContent = collapsed ? moreLabel : root.dataset.less;
      });
      list.after(button);
    });
  };
  const init = () => document.querySelectorAll('[data-product-highlights]').forEach(setup);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
